function ZonesData() {
    "use strict";

    this.CurrentId = -1;
    this.EditItem = null;
    this.EditShape = null;
    this.Clean = null;
    this.Sort = null;
    this.Dirty = null;
    this.Paginated = null;
    this.EditVertices = null;
    this.DistancePoints = [];
    this.DistanceToolActive = false;
    this.TargetId = -1;
    this.TempId = -1;
    this.EditMode = false;
    this.NewZoneId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = ZonesData;
}